module.exports = __webpack_public_path__ + "img/selected5-min.7113a688.png";